<template>
    <div class="publicity">
        <div class="header">
            <app-home-header :is-fixed="true"></app-home-header>
        </div>
        <div class="publicity-commitment">
            <img src="@/assets/images/recordPublicity/page1.jpg" alt="">
            <img src="@/assets/images/recordPublicity/page2.jpg" alt="">
        </div>
        <app-footer :simple="false"></app-footer>
    </div>
</template>

<script>
import AppHomeHeader from './AppHomeHeader';
import AppFooter from './AppFooter';
export default {
    components: {
        AppHomeHeader,
        AppFooter
    }
};
</script>

<style lang="scss" scoped>
.publicity {
    background: #fff;
    .header {
        height: 70px;
    }
}
.publicity-commitment {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 50px;
    min-height: 800px;
    img {
        display: block;
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/PublicityCommitment.vue